module.exports = __webpack_public_path__ + "img/logo.5469d67e.jpg";